import React from 'react';
import { AlertTriangle, Home } from 'lucide-react';

interface GameOverModalProps {
  onReturnToMenu: () => void;
}

export function GameOverModal({ onReturnToMenu }: GameOverModalProps) {
  return (
    <>
      <div className="bg-theme-error p-4">
        <div className="flex items-center gap-3">
          <div className="flex-shrink-0">
            <AlertTriangle className="w-6 h-6 text-white" />
          </div>
          <h3 className="text-lg font-medium text-white">
            Game Over - Bankruptcy
          </h3>
        </div>
      </div>
      <div className="p-6">
        <p className="text-theme-text-secondary mb-6">
          Your company has been declared bankrupt. Unfortunately, this marks the end of your business venture.
        </p>
        <div className="space-y-4">
          <div className="bg-theme-bg-secondary p-4 rounded-lg">
            <h4 className="font-medium text-theme-text-primary mb-2">Game Summary:</h4>
            <ul className="text-sm text-theme-text-secondary space-y-2">
              <li>• Multiple financial losses led to bankruptcy</li>
              <li>• Unable to maintain positive cash flow</li>
              <li>• Business operations have ceased</li>
            </ul>
          </div>
          <button
            type="button"
            onClick={onReturnToMenu}
            className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-theme-accent text-white rounded-lg hover:opacity-90 transition-colors focus:outline-none focus:ring-2 focus:ring-theme-accent focus:ring-offset-2"
          >
            <Home className="w-5 h-5" />
            Return to Main Menu
          </button>
        </div>
      </div>
    </>
  );
}